export enum FeatureFlagKey {
    AllowOnboardingSkip = 'allow-onboarding-skip',
    OnboardingAlternateValueProposition = 'onboarding-alternate-value-proposition',
}
